<template slot-scope="scope">
  <!-- 车险活动购买信息弹窗 -->
  <div>
      <dialogModel
        title="信息卡购买"
        :visible.sync="dialogInformationCard"
        @handleClose="handleClosePurchase"
        @handleOk="handlePurchase"
      >
        <div>
          <div class="from-box">
            <p>套餐选择：</p>
          </div>
          <div class="from-box">
            <p
              v-for="(item, index) in SetMeal"
              :key="index"
              :class="
                SetMealSelect == item.id
                  ? 'change-box change-box-active'
                  : 'change-box'
              "
              @click="SetMealChange(item, index)"
            >
              {{ item.count }}次/月
            </p>
          </div>
          <div class="from-box" style="margin-top: 10px">
            <p>到期时间：</p>
            <p class="end-p">{{ CalculationData.endTime || "--" }}到期</p>
          </div>
          <div class="from-box" style="margin-top: 10px">
            <p>侦迹币数量：{{ CalculationData.companyTraceCoin || "--" }}</p>
          </div>
          <div class="from-box" style="margin-top: 10px">
            <p>
              金额：<span style="color: red">{{
                CalculationData.amount + "元"  || "--"
              }}</span>
            </p>
          </div>
          <div class="from-box" style="margin-top: 10px">
            <p>支付方式：</p>
          </div>
          <div class="from-box">
            <p
              v-for="(item, index) in list"
              :key="index"
              :class="
                listSelect == item.id
                  ? 'change-box change-box-active'
                  : 'change-box'
              "
              @click="listSelect = item.id"
            >
              {{ item.name }}
            </p>
          </div>
        </div>
      </dialogModel>
    <!-- 二维码弹窗 -->
    <CommonPayment
      :VisiblePayment="VisiblePayment"
      :alipayForm="alipayForm"
      :payMethod="payMethod"
      :totalAmount="totalAmount"
      :orderId="orderId"
      :businessType="businessType"
      :queryType="'info'"
      @handlePayment="handlePayment"
      @handleSuccess="handleSuccess"
    ></CommonPayment>
    <!-- 支付密码验证 -->
    <VerificationPwd
      :VisiblePwd="VisiblePwd"
      @handleClosePwd="VisiblePwd = false"
      @handleUnderstandPwd="handleUnderstandPwd"
    ></VerificationPwd>
  </div>
</template>

<script>
import {} from "../../../../../assets/api/index";
import {
  queryCompanyPaySetting, //查询是否开通了支付密码
} from "../../../../../assets/api/Agency/Enterprise";
import CommonPayment from "@/components/CommonPayment.vue";
import VerificationPwd from "../../../firmCenter/ProxyService/Enterprise/Bookkeeping/components/IndexCom/VerificationPwd.vue"; //支付密码验证
import {
  getSysPropPrice, //价格
  calculateBuyPropPrice, //计算价格
  pay, //购买
} from "../../../../../assets/api/firm/Opportunity";
import { PAYMENT_OPTIONS, DEFAULT_PAYMENT_METHOD, PAYMENT_METHODS } from "@/utils/paymentMethods";

export default {
  props: {
    dialogInformationCard: {},
  },
  components: {
    CommonPayment,
    VerificationPwd,
  },
  data() {
    return {
      SetMeal: [], //价格选择
      SetMealSelect: 0, //选中
      CalculationData: {}, //选择价格计算出的数据
      list: [
        ...PAYMENT_OPTIONS,
        { name: "侦迹币", id: PAYMENT_METHODS.TRACE_COIN },
      ],
      listSelect: DEFAULT_PAYMENT_METHOD,
      PaymentPassword: false, //查询是否开启支付密码
      VisiblePwd: false, //支付密码验证

      alipayForm: ``, //支付弹窗二维码
      totalAmount: "",
      businessType: "",
      payMethod: "",
      orderId: "",
      VisiblePayment: false, //扫码支付弹窗
    };
  },
  computed: {},
  created() {
    this.getSysPropPrice();
    this.queryCompanyPaySetting();
  },
  methods: {
    //付款成功
    handleSuccess() {
      this.VisiblePayment = false;
      this.$router.push("/PaymentCompleted");
    },
    // 付款取消
    handlePayment() {
      this.VisiblePayment = false;
    },
    // 查询是否开通支付密码
    queryCompanyPaySetting() {
      queryCompanyPaySetting().then((res) => {
        if (res.code == 0) {
          this.PaymentPassword = res.data;
        }
      });
    },
    // 点击选择套餐
    SetMealChange(item, index) {
      if (this.SetMealSelect == item.id) {
      } else {
        this.SetMealSelect = item.id;
        this.calculateBuyPropPrice();
      }
    },
    //获取信息卡价格
    getSysPropPrice() {
      getSysPropPrice({ data: 3 }).then((res) => {
        if (res.code == 0) {
          this.SetMeal = res.data;
          this.SetMealSelect = res.data[0].id;
          this.calculateBuyPropPrice();
        }
      });
    },
    // 计算价格
    calculateBuyPropPrice() {
      var data = {
        data: {
          propId: 3,
          priceId: this.SetMealSelect,
          buyNum: 1,
        },
      };
      calculateBuyPropPrice(data).then((res) => {
        if (res.code == 0) {
          this.CalculationData = res.data;
        }
      });
    },
    // 关闭弹窗
    handleClosePurchase() {
      this.$emit("handleClosePurchase");
    },
    handlePurchase() {
      // 确认
      // 支付提交
      if (this.PaymentPassword == false) {
        //没有开启支付密码验证直接弹支付二维码
        this.handleUnderstandPwd();
      } else {
        // 支付密码验证
        this.VisiblePwd = true;
      }
    },
    // 支付密码确认成功提交
    handleUnderstandPwd(pwd) {
      this.VisiblePwd = false;
      // pwd支付密码
      var data = {
        data: {
          businessType: "BUSINESS_INFO_CARD_BUY",
          payMethod: this.listSelect,
          password: pwd,
          businessInfo: {
            priceId: this.SetMealSelect,
            count: 1,
            useTraceCoin:
              this.listSelect == PAYMENT_METHODS.TRACE_COIN ? 1 : 0,
          },
        },
      };
      pay(data).then((res) => {
        if (res.code == 0) {
          if (this.listSelect == PAYMENT_METHODS.TRACE_COIN) {
            // 侦迹币
            this.$emit("handlePurchaseCompleted");
            this.$tool.PromptBox("success", "购买成功");
          } else {
            // 支付宝/微信：弹二维码
            this.alipayForm = res.data.payPage || "";
            this.totalAmount = res.data.totalAmount || "";
            this.orderId = res.data.orderId || "";
            this.businessType =
              res.data.businessType || data.data.businessType;
            this.payMethod = res.data.payMethod || data.data.payMethod;
            this.VisiblePayment = true;
          }
        }
      });
    },
  },
};
</script>

<style scoped lang="less">
.dialog-title {
  width: 100%;
  height: 60px;
  .off {
    width: 100%;
    height: 28px;
    display: flex;
    justify-content: flex-end;
    div {
      width: 18px;
      height: 18px;
      background-image: url("../../../../../assets/imgs/guanbi.svg");
      background-size: 100% 100%;
      margin-top: 15px;
    }
  }
  .Instructions {
    font-size: 12px;
    color: #999999;
  }
  p {
    width: 100%;
    height: 28px;
    line-height: 28px;
    font-family: PingFangSC-Medium;
    font-size: 16px;
    color: #409eff ;
    text-align: center;
    font-weight: 400;
  }
}
.from-box {
  width: 500px;
  margin: 0 auto;
  display: flex;
  min-height: 30px;
  line-height: 30px;
  .change-box {
    width: 90px;
    height: 35px;
    line-height: 35px;
    background: #ffffff;
    border: 1px solid #409eff ;
    border-radius: 5px;
    font-size: 12px;
    text-align: center;
    color: #409eff ;
    cursor: pointer;
    margin-right: 10px;
    margin-bottom: 10px;
    box-sizing: border-box;
  }

  .change-box-active {
    background: rgba(97, 144, 232, 0.27);
  }
}
</style>
